const EN_LANG = 2;

const RATE_COLOR = {
    RED_UP: 'redup',
    RED_DOWN: 'reddown'
};
const SHOW_ENUM = {
    SHOW: 1,
    HIDE: 0
};
const STOCK_TYPE = {
    STOCK: 0,
    PLATE: 1
};

const DIRECT_ENUM = {
    up: 'up',
    down: 'down'
};

const PLATE_SHOW_FIELD = {
    SRC_CODE: 0,
    NAME: 1
};

export {
    EN_LANG,
    RATE_COLOR,
    STOCK_TYPE,
    SHOW_ENUM,
    DIRECT_ENUM,
    PLATE_SHOW_FIELD
};
